export const ORIGINATIONS_PAGINATION = {
    INITIAL_PAGE_SIZE: 10,
    PAGE_SIZE: 10,
    SKELETON_COUNT: 3, // Number of skeleton rows to show while "loading"
};

// Must match RelatedAccountsConstants on the server; it lists the sources whose lookup failed.
export const RELATED_ACCOUNTS_SOURCES = {
    LOAD_PAY: 'loadPay',
    ORIGINATIONS: 'originations',
    DELTA: 'delta',
} as const;

export const RELATED_ACCOUNTS_PARTIAL_COUNT_TITLE = 'Some related accounts could not be loaded';
